import {Action, Selector, State, StateContext} from '@ngxs/store';
import {Injectable} from '@angular/core';
import {tap} from 'rxjs/operators';
import {Observable, of} from 'rxjs';
import Organization from '../models/organization/organization.model';
import {OrganizationActions} from '../actions/organiztion.actions';
import {OrganizationService} from '../services/organization.service';
import {Auth} from '../actions/auth.actions';
import {getCurrencySymbol} from '@angular/common';
import GetOrganization = OrganizationActions.GetOrganization;
import ClearState = Auth.ClearState;
import UpdateOrganization = OrganizationActions.UpdateOrganization;

export interface OrganizationStateModel {
  organization: Organization | null;
  currencySymbol: string | null;
}

@State<OrganizationStateModel>({
  name: 'organization',
  defaults: {
    organization: null,
    currencySymbol: null,
  }
})
@Injectable()
export class OrganizationState {
  constructor(private organizationService: OrganizationService) {
  }

  @Selector()
  static organization(state: OrganizationStateModel): Organization | null {
    return state.organization;
  }

  @Selector()
  static currency(state: OrganizationStateModel): string | null {
    return state.currencySymbol;
  }

  @Action(GetOrganization)
  getOrganization(ctx: StateContext<OrganizationStateModel>, action: GetOrganization): Observable<Organization> {
    const organization = ctx.getState().organization;
    if (organization && organization.handle === action.handle) {
      return of(organization);
    }
    return this.organizationService.getOrganization(action.handle).pipe(
      tap((result: Organization) => {
        ctx.patchState({
          organization: result,
          currencySymbol: getCurrencySymbol(result.currency, 'narrow')
        });
      })
    );
  }

  @Action(UpdateOrganization)
  updateOrganization(ctx: StateContext<OrganizationStateModel>, action: UpdateOrganization): Observable<Organization> {
    return this.organizationService.updateOrganization(action.id, action.organization).pipe(
      tap((result: Organization) => {
        ctx.patchState({
          organization: result,
          currencySymbol: getCurrencySymbol(result.currency, 'narrow')
        });
      })
    );
  }

  @Action(ClearState)
  clearState(ctx: StateContext<OrganizationStateModel>): void {
    ctx.setState({
      organization: null,
      currencySymbol: null,
    });
  }
}
